
import { Component, Prop, Vue } from 'nuxt-property-decorator'

@Component
export default class CollapseToggle extends Vue {
  @Prop({ required: true, default: false, type: Boolean })
  readonly expanded!: boolean

  @Prop({ required: false, default: false, type: Boolean })
  readonly bordered!: boolean

  @Prop({ required: false, default: 'mobile', type: String })
  readonly type!: string

  onClick () {
    this.$emit('click')
  }
}
